import {Action, Selector, State, StateContext} from "@ngxs/store";
import {Injectable} from "@angular/core";
import {ResetStateDefaults} from "../base-action-class.model";
import {ChecklistTemplateOverallAssessmentAction} from "./checklist-template-overall-assessment.action";
import {Observable} from "rxjs/internal/Observable";
import {
  AssessmentWithSeverityAction
} from "../../models/assessment-with-severity-action/assessment-with-severity-action.model";
import {throwError} from "rxjs/internal/observable/throwError";
import {RequestClientService} from "../../services/client/request-client.service";
import {
  AssessmentWithSeverityActionRequestService
} from "../../services/request/assessment-with-severity-action-request.service";
import {finalize} from "rxjs";
import {delay, map} from "rxjs/operators";

interface ChecklistTemplateOverallAssessmentStateModel {
  checklistTemplateVersionId: string | null;
  assessmentsWithSeverityActions: AssessmentWithSeverityAction[] | null;
  inProgress: boolean;
}

const getDefaults = (): ChecklistTemplateOverallAssessmentStateModel => ({
  checklistTemplateVersionId: null,
  assessmentsWithSeverityActions: null,
  inProgress: false
});

@State<ChecklistTemplateOverallAssessmentStateModel>({
  name: 'checklistTemplateOverallAssessment',
  defaults: getDefaults()
})
@Injectable()
export class ChecklistTemplateOverallAssessmentXsState {

  //region CONSTRUCTOR
  constructor(
    private assessmentWithSeverityActionRequestService: AssessmentWithSeverityActionRequestService,
    private requestService: RequestClientService,
  ) {
  }
  //endregion

  //region SELECTORS
  @Selector()
  static assessmentsWithSeverityActions(
    state: ChecklistTemplateOverallAssessmentStateModel
  ): AssessmentWithSeverityAction[] | null {
    return state.assessmentsWithSeverityActions;
  }
  //endregion

  //region ACTIONS
  @Action(ChecklistTemplateOverallAssessmentAction.Fetch)
  public fetch(
    ctx: StateContext<ChecklistTemplateOverallAssessmentStateModel>,
    action: ChecklistTemplateOverallAssessmentAction.Fetch
  ): Observable<void> {

    if (!action.checklistTemplateVersionId) {
      return throwError(() => new Error('Checklist template version id cannot be null!'));
    }

    ctx.patchState({
      checklistTemplateVersionId: action.checklistTemplateVersionId,
      inProgress: true,
      assessmentsWithSeverityActions: null,
    });

    const requestStartDate: Date = new Date();

    return this.assessmentWithSeverityActionRequestService
      .getInheritedAssessmentsWithSeverityActionForChecklistTemplateVersion(action.checklistTemplateVersionId)
      .pipe(
        delay(this.requestService.calcDefaultTimeoutOf(requestStartDate)),
        map((assessmentsWithSeverityActions: AssessmentWithSeverityAction[]) => {
          ctx.patchState({
            assessmentsWithSeverityActions
          });
        }),
        finalize(() => ctx.patchState({inProgress: false}))
      );
  }

  @Action([
    ChecklistTemplateOverallAssessmentAction.ResetState,
    ResetStateDefaults
  ])
  public resetState(ctx: StateContext<ChecklistTemplateOverallAssessmentStateModel>): void {
    ctx.setState(getDefaults);
  }
  //endregion

}
